import React from 'react';
import { motion } from 'framer-motion';
import { MindMapCanvas } from '../../components/MindMap';

const NetworkPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="h-full"
    >
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-heading font-semibold text-zinc-100 mb-1">Network Map</h1>
        <p className="text-zinc-500 text-sm">
          Visualize connections between contacts and organizations
        </p>
      </div>

      {/* Full screen canvas */}
      <div 
        className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen"
        style={{ zIndex: 0 }}
      >
        <MindMapCanvas mapId="network" />
      </div>
      {/* Empty placeholder to maintain layout flow */}
      <div className="h-[calc(100vh-120px)]" />
    </motion.div>
  );
};

export default NetworkPage;
